import { render, staticRenderFns } from "./TabelaUsuarioAplicacao.vue?vue&type=template&id=4203d1fe&scoped=true"
import script from "./TabelaUsuarioAplicacao.vue?vue&type=script&lang=js"
export * from "./TabelaUsuarioAplicacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaUsuarioAplicacao.vue?vue&type=style&index=0&id=4203d1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4203d1fe",
  null
  
)

export default component.exports